import React from "react";
import { addDesignation } from "../../Services/postServices";

const UserManagement=()=>{


    return(

        <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          <h5 className="h2_heading">User Management </h5>
          <br></br>
        

          <button className="btn btn-primary">Add Role <i class="fa fa-plus"></i></button>
          <button className="btn btn-primary" style={{marginLeft:"2rem"}}>Delete Role <i class="fa fa-trash"></i></button>

          </div>
          </div>

    )

}

export default UserManagement;